import cloneDeep from "lodash/cloneDeep";
import throttle from "lodash/throttle";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import React from "react";
import { allData } from "./constant";
import "./TableSearchPagination.css";

const tableHead = {
  photo: "Photo",
  name: "Name",
  mobile: "Mobile",
  email: "Email",
  mart: "Mart",
  action: "Actions",
};

const TableSearchPagination = () => {
  const countPerPage = 10;
  const [value, setValue] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(1);
  const [collection, setCollection] = React.useState(
    cloneDeep(allData.slice(0, countPerPage))
  );
  const searchData = React.useRef(
    throttle((val) => {
      const query = val.toLowerCase();
      setCurrentPage(1);
      const data = cloneDeep(
        allData
          .filter((item) => item.name.toLowerCase().indexOf(query) > -1)
          .slice(0, countPerPage)
      );
      setCollection(data);
    }, 400)
  );

  React.useEffect(() => {
    if (!value) {
      updatePage(1);
    } else {
      searchData.current(value);
    }
  }, [value]);

  const updatePage = (p) => {
    setCurrentPage(p);
    const to = countPerPage * p;
    const from = to - countPerPage;
    setCollection(cloneDeep(allData.slice(from, to)));
  };

  const tableRows = (rowData) => {
    const { key, index } = rowData;
    const tableCell = Object.keys(tableHead);
    const columnData = tableCell.map((keyD, i) => {
      return (
        <td className="tdCell" key={i}>
          {key[keyD]}
        </td>
      );
    });

    return (
      <tr className="trCell" key={index}>
        {columnData}
      </tr>
    );
  };

  const tableData = () => {
    return collection.map((key, index) => tableRows({ key, index }));
  };

  const headRow = () => {
    return Object.values(tableHead).map((title, index) => (
      <td className="tdCell" key={index}>
        {title}
      </td>
    ));
  };

  return (
    <div className="tableApp">
      <div className="search">
        <input
          className="inputSearch"
          placeholder="Search Campaign"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
      <div className="table-x">
      <table className="tableCell">
        <thead className="theadCell text-primary">
          <tr className="trCell">{headRow()}</tr>
        </thead>
        <tbody className="trhover">{tableData()}</tbody>
      </table>
      </div>


      <div className="learningSessionPagination">
        <Pagination
          pageSize={countPerPage}
          onChange={updatePage}
          current={currentPage}
          total={allData.length}
        />
      </div>
    </div>
  );
};
export default TableSearchPagination;
